<template>
  <div>
    <v-dialog persistent v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title class="justify-center"> {{ caseName }} 的健康數據 </v-card-title>
        <v-card-subtitle class="pa-2">
          <v-row dense v-if="localExist" class="my-2 justify-center">
            <v-btn color="#614BC3" class="white--text mr-2" @click="enterNewData">
              ✚新增資料
            </v-btn>
            <v-btn color="#BB2525" class="white--text" @click="viewVitalSignHistory">
              查看歷史數據
            </v-btn>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="選擇日期"
                  v-model="localDate"
                  type="date"
                  prepend-icon="mdi-calendar"
                  :rules="dateRules"
                  hide-details="true"
                  class="my-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="6">
                    <v-select
                      dense
                      outlined
                      :items="hours"
                      v-model="selectedHour"
                      label="時"
                      class="my-2 px-2"
                      hide-details
                      @change="updateTime"
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      dense
                      outlined
                      :items="minutes"
                      v-model="selectedMinute"
                      label="分"
                      class="my-2 px-2"
                      hide-details
                      @change="updateTime"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="體溫"
                  v-model="localTemperature"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="收縮壓"
                  v-model="localShrink"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="舒張壓"
                  v-model="localRelax"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="心率"
                  v-model="localHr"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="血氧"
                  v-model="localSpo2"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="呼吸"
                  v-model="localBreathe"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider />
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="體重"
                  v-model="localWeight"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  label="血糖"
                  v-model="localBs"
                  type="number"
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="my-2" />
            <v-row dense>
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  hide-details
                  label="備註"
                  v-model="localRemark"
                  :readonly="readonly"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="localExist" dense class="justify-center">
            <v-btn text color="blue" @click="closeDialog">關閉</v-btn>
          </v-row>
          <v-row v-else dense class="justify-space-around">
            <v-btn text color="red" @click="closeDialog">取消</v-btn>
            <v-btn text color="green" @click="submit">送出</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="history_dialog" v-model="history_dialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          {{ caseName }} 的歷史健康數據
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeHistoryDialog">關閉</v-btn>
        </v-card-title>
        <v-card-text>
          <v-overlay :value="loading" absolute>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-form ref="form">
            <v-row
              dense
              :class="['default-border', isEditing(record) ? 'editing-border' : '']"
              v-for="record in vitalSignHistory"
              :key="record.vital_sign_id"
              class="relative-position pa-2 my-2"
            >
              <!-- 編輯按鈕 -->
              <v-btn
                icon
                small
                class="edit-btn"
                :class="{ 'confirm-btn': isEditing(record) }"
                @click="toggleEdit(record)"
              >
                <v-icon>{{ isEditing(record) ? 'mdi-check' : 'mdi-pencil' }}</v-icon>
              </v-btn>
              <!-- 刪除按鈕 -->
              <v-btn icon small class="delete-btn" @click="deleteConfirm(record)">
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>

              <!-- 紀錄時間不可修改 -->
              <v-col cols="12">
                <v-text-field
                  label="紀錄時間"
                  :value="formatDate(record.record_datetime)"
                  prepend-icon="mdi-calendar"
                  readonly
                  class="my-2"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.temperature !== null">
                <v-text-field
                  dense
                  outlined
                  label="體溫"
                  v-model="record.temperature"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.hr !== null">
                <v-text-field
                  dense
                  outlined
                  label="心率"
                  v-model="record.hr"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.shrink !== null && record.relax !== null">
                <v-text-field
                  dense
                  outlined
                  label="收縮壓"
                  v-model="record.shrink"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.shrink !== null && record.relax !== null">
                <v-text-field
                  dense
                  outlined
                  label="舒張壓"
                  v-model="record.relax"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.SPO2 !== null">
                <v-text-field
                  dense
                  outlined
                  label="血氧"
                  v-model="record.SPO2"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.breathe !== null">
                <v-text-field
                  dense
                  outlined
                  label="呼吸"
                  v-model="record.breathe"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.blood_sugar !== null">
                <v-text-field
                  dense
                  outlined
                  label="血糖"
                  v-model="record.blood_sugar"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="record.weight !== null">
                <v-text-field
                  dense
                  outlined
                  label="體重"
                  v-model="record.weight"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                ></v-text-field>
              </v-col>
              <v-divider class="my-2" />
              <v-col cols="12" v-if="record.remark !== null && record.remark !== undefined">
                <v-textarea
                  dense
                  outlined
                  label="備註"
                  v-model="record.remark"
                  :readonly="!isEditing(record)"
                  :flat="!isEditing(record)"
                  hide-details="true"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialog" max-width="400">
      <v-card>
        <v-card-title> 確定刪除 {{ caseName }} 的生理數據紀錄？ </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDeleteDialog = false">取消</v-btn>
          <v-btn color="red darken-1" text @click="deleteData">確定刪除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import qs from 'qs'
export default {
  name: 'VitalSignDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    caseName: {
      type: String,
      default: '',
    },
    exist: {
      type: Boolean,
      default: false,
    },
    caseId: {
      type: String,
      required: true,
    },
    staffId: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
    time: {
      type: String,
      default: () => moment().format('HH:mm'),
    },
    temperature: {
      type: [String, Number],
    },
    hr: {
      type: [String, Number],
    },
    shrink: {
      type: [String, Number],
    },
    relax: {
      type: [String, Number],
    },
    spo2: {
      type: [String, Number],
    },
    breathe: {
      type: [String, Number],
    },
    bs: {
      type: [String, Number],
    },
    weight: {
      type: [String, Number],
    },
  },
  data() {
    return {
      // local data 用作雙向綁定，初始值從 props 複製
      localDate: this.date,
      localTime: this.time,
      localTemperature: this.temperature,
      localHr: this.hr,
      localShrink: this.shrink,
      localRelax: this.relax,
      localSpo2: this.spo2,
      localBreathe: this.breathe,
      localBs: this.bs,
      localWeight: this.weight,
      localRemark: '',
      dateRules: [(v) => !!v || '此欄位不可為空'],
      timeRules: [(v) => !!v || '此欄位不可為空'],
      localExist: this.exist, // 控制是否已有資料
      readonly: this.exist,
      vitalSignHistory: [],
      history_dialog: false,
      editingRecord: null,
      confirmDeleteDialog: false,
      confirmRecord: null,
      loading: false,
      hours: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')),
      minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')),
      selectedHour: '12',
      selectedMinute: '00',
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  mounted() {
    this.initializeTimeSelector()
  },
  methods: {
    updateTime() {
      this.localTime = `${this.selectedHour}:${this.selectedMinute}`
    },
    initializeTimeSelector() {
      if (this.localTime) {
        const time = moment(this.localTime, ['HH:mm', 'h:mm A', 'h:mm']).format('HH:mm')
        const [hour, minute] = time.split(':')
        this.selectedHour = hour
        this.selectedMinute = minute
        this.localTime = time
      } else {
        const now = moment()
        this.selectedHour = now.format('HH')
        this.selectedMinute = now.format('mm')
        this.localTime = `${this.selectedHour}:${this.selectedMinute}`
      }
    },
    closeDialog() {
      this.dialog = false
      this.$emit('update', {
        date: this.localDate,
        time: this.localTime,
        temperature: this.localTemperature,
        hr: this.localHr,
        shrink: this.localShrink,
        relax: this.localRelax,
        spo2: this.localSpo2,
        breathe: this.localBreathe,
        bs: this.localBs,
        weight: this.localWeight,
        remark: this.localRemark,
      })
      this.resetForm()
    },
    resetForm() {
      this.localDate = this.date
      this.localTime = this.time
      this.initializeTimeSelector()
      this.localTemperature = this.temperature
      this.localHr = this.hr
      this.localShrink = this.shrink
      this.localRelax = this.relax
      this.localSpo2 = this.spo2
      this.localBreathe = this.breathe
      this.localBs = this.bs
      this.localWeight = this.weight
      this.localRemark = ''
      this.localExist = this.exist
      this.readonly = this.exist
    },
    enterNewData() {
      this.localExist = false
      this.readonly = false
      this.localDate = moment().format('YYYY-MM-DD')
      this.localTime = moment().format('HH:mm')
      this.initializeTimeSelector()
      this.localTemperature = ''
      this.localHr = ''
      this.localShrink = ''
      this.localRelax = ''
      this.localSpo2 = ''
      this.localBreathe = ''
      this.localBs = ''
      this.localWeight = ''
      this.localRemark = ''
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const formattedTime = moment(`${this.localDate}T${this.localTime}`).format()
        const data = qs.stringify({
          action: 'create',
          employee_id: this.staffId,
          temperature: this.localTemperature,
          hr: this.localHr,
          shrink: this.localShrink,
          relax: this.localRelax,
          blood_sugar: this.localBs,
          SPO2: this.localSpo2,
          breathe: this.localBreathe,
          weight: this.localWeight,
          remark: this.localRemark,
          datetime: formattedTime,
        })
        const config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `/api/attendance/vitalsigns/${this.caseId}/`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: data,
        }
        try {
          const res = await axios.request(config)
          console.log(res.data)
          this.$emit('get_list')
          this.$emit('get_vitalSign')
        } catch (error) {
          console.error(error)
        }
        this.closeDialog()
      }
    },
    async viewVitalSignHistory() {
      this.dialog = false
      await this.$nextTick()
      this.history_dialog = true
      const currentDate = moment().format('YYYY-MM-DD')
      let config = {
        method: 'get',
        url: `/api/attendance/vitalsigns/history/${this.caseId}/?date=${currentDate}`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.vitalSignHistory = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async editVitalSign(record) {
      this.loading = true
      const data = qs.stringify({
        temperature: record.temperature,
        hr: record.hr,
        shrink: record.shrink,
        relax: record.relax,
        blood_sugar: record.blood_sugar,
        SPO2: record.SPO2,
        breathe: record.breathe,
        weight: record.weight,
        remark: record.remark || '',
        employee_id: record.employee_id,
      })
      try {
        const response = await axios.post(
          `/api/attendance/vitalsigns/${this.caseId}/edit/${record.vital_sign_id}/`,
          data
        )
        await this.viewVitalSignHistory()
        this.$emit('get_list')
        await new Promise((resolve) => {
          this.$emit('get_vitalSign')
          setTimeout(resolve, 1000)
        })
      } catch (error) {
        console.log(`資料更新失敗：${error.response?.data?.message || error.message}`)
      } finally {
        this.loading = false
      }
    },
    async deleteData() {
      this.loading = true
      try {
        await axios.post(
          `/api/attendance/vitalsigns/${this.caseId}/delete/${this.confirmRecord.vital_sign_id}/`
        )
        await this.viewVitalSignHistory()
        this.$emit('get_list')
        await new Promise((resolve) => {
          this.$emit('get_vitalSign')
          setTimeout(resolve, 1000)
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.confirmDeleteDialog = false
      }
    },
    deleteConfirm(record) {
      this.confirmRecord = record
      this.confirmDeleteDialog = true
    },
    isEditing(record) {
      return this.editingRecord === record
    },
    toggleEdit(record) {
      if (this.editingRecord === record) {
        this.editVitalSign(record)
        this.editingRecord = null
      } else {
        this.editingRecord = record
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date
        .toLocaleString(undefined, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    },
    async closeHistoryDialog() {
      this.history_dialog = false
      await this.$nextTick()
      this.$emit('trigger_selection', this.caseName, this.caseId)
    },
  },
  watch: {
    exist(newVal) {
      this.localExist = newVal
      this.readonly = newVal
    },
    value(newVal) {
      if (newVal) {
        this.initializeTimeSelector()
      } else {
        this.resetForm()
      }
    },
    date(newVal) {
      this.localDate = newVal
    },
    time(newVal) {
      if (newVal) {
        const time = moment(newVal, ['HH:mm', 'h:mm A', 'h:mm']).format('HH:mm')
        const [hour, minute] = time.split(':')
        this.selectedHour = hour
        this.selectedMinute = minute
        this.localTime = time
      }
    },
    temperature(newVal) {
      this.localTemperature = newVal
    },
    hr(newVal) {
      this.localHr = newVal
    },
    shrink(newVal) {
      this.localShrink = newVal
    },
    relax(newVal) {
      this.localRelax = newVal
    },
    spo2(newVal) {
      this.localSpo2 = newVal
    },
    breathe(newVal) {
      this.localBreathe = newVal
    },
    bs(newVal) {
      this.localBs = newVal
    },
    weight(newVal) {
      this.localWeight = newVal
    },
  },
}
</script>

<style scoped>
.hover-effect:hover {
  cursor: pointer;
  color: #4477ce;
}
.hover-add:hover {
  cursor: pointer;
  color: #258525;
}
.default-border {
  border: 2px solid gray;
  border-radius: 5px;
}

.editing-border {
  border: 4px solid #1976d2 !important;
  transition: border 0.2s ease-in-out;
}

.relative-position {
  position: relative;
}

.edit-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 45px;
}

.confirm-btn {
  background-color: #4caf50 !important;
  color: white !important;
}

.v-overlay {
  z-index: 1002 !important;
}
</style>
